import { Component, Input } from "@angular/core";
import { AbstractButtonComponent } from "./abstract-button.component";

@Component({
    selector: 'sy-button',
    template: `
        <ng-container [ngSwitch]="type">
            <outlined-button *ngSwitchCase="'OUTLINED'" [label]="label" [disabled]="disabled" [cssClass]="cssClass" [critical]="critical" (buttonClick)="buttonClick.emit()"></outlined-button>
            <standard-button *ngSwitchCase="'STANDARD'" [label]="label" [disabled]="disabled" [cssClass]="cssClass" [critical]="critical" (buttonClick)="buttonClick.emit()"></standard-button>
            <filled-button  *ngSwitchDefault [label]="label" [disabled]="disabled" [cssClass]="cssClass" [critical]="critical" (buttonClick)="buttonClick.emit()"></filled-button>
        </ng-container>  
    `
})
export class ServitlyButtonComponent extends AbstractButtonComponent {

    @Input() type: ButtonType = 'FILLED';

}

type ButtonType = 'FILLED' | 'OUTLINED' | 'STANDARD';